var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"f664cf9faaed7201a0d1289a53825d6c5905fbec"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// sentry.client.config.js
// Aligns with shared strategy: project/tenantId/userRole/action tags, severity, sampling.

import * as Sentry from "@sentry/nextjs";
import { SENTRY_PROJECT, SENTRY_TAGS } from "./lib/sentry/constants";

const SENTRY_DSN =
  process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

const environment =
  process.env.NODE_ENV === "production"
    ? process.env.NEXT_PUBLIC_VERCEL_ENV || "production"
    : process.env.NODE_ENV || "development";

Sentry.init({
  dsn:
    SENTRY_DSN ||
    "https://ccb637e9c278493c803377603ea5909f@o4504912284549120.ingest.sentry.io/4504952455036928",

  release: process.env.SENTRY_RELEASE || process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || undefined,
  environment,

  // ATT-2937: lowered to ease the shared Sentry span quota (org was rate-limited).
  tracesSampleRate: 0.1,

  initialScope: {
    tags: {
      [SENTRY_TAGS.project]: SENTRY_PROJECT,
      [SENTRY_TAGS.environment]: environment,
    },
  },

  beforeSend(event, hint) {
    // Ensure project + environment on every event
    if (!event.tags) event.tags = {};
    event.tags[SENTRY_TAGS.project] = SENTRY_PROJECT;
    event.tags[SENTRY_TAGS.environment] = environment;

    // Downgrade known recoverable/expected errors to warning
    const message = (event.message || hint.originalException?.message || "").toString();
    if (
      /session.*expir|unauthorized|401|validation/i.test(message) ||
      (event.exception?.values?.[0]?.value && /UNAUTHORIZED|validation/i.test(event.exception.values[0].value))
    ) {
      event.level = "warning";
    }

    // Sample out low-value info-level if we ever send them
    if (event.level === "info" && Math.random() > 0.1) {
      return null;
    }

    return event;
  },

  ignoreErrors: [
    "ResizeObserver loop",
    "undefined is not an object",
    /runtime\.sendMessage/i,
    /Extension context invalidated/i,
    /Tab not found/i,
    /message channel closed/i,
    /Cannot read properties of undefined \(reading 'sendMessage'\)/i,
    /Script error\.?$/i,
    /Non-Error promise rejection captured/i,
    /Load failed/i,
    /Failed to fetch/i,
    /NetworkError/i,
    /AbortError/i,
    // 4xx tenant-routing misconfig — a request without (or with a bad)
    // X-Tenant-Domain header gets a 400 and graphql-request throws a ClientError
    // whose message carries the code. It's a malformed request, not a system
    // fault, so it must not alert/page (mirrors the backend 4xx-vs-5xx policy,
    // ATT-2937). The backend never sends these to Sentry; this drops the
    // client-side capture.
    /MISSING_TENANT_DOMAIN/i,
    /MALFORMED_DOMAIN/i,
    /MISSING_BROWSER_CROSS_CHECK/i,
    /TENANT_MISMATCH/i,
  ],

  denyUrls: [
    /chrome-extension:\/\//i,
    /moz-extension:\/\//i,
    /safari-extension:\/\//i,
  ],
});
